import React from "react";
import { RouteComponentProps } from "react-router";
import { withRouter } from "react-router-dom";
import { logUserIn } from "../auth";
import queryString from "query-string";
import { capturePostHogEvent } from "../utils/posthog";
import jwtDecode from "jwt-decode";

/* tslint:disable:no-var-requires */
const qs = require("qs");

const isLikelyJwt = (value: unknown): value is string =>
  typeof value === "string" && value.split(".").length === 3;

const ReceiveJwt: React.SFC<RouteComponentProps> = ({ history, location }) => {
  const handleJwt = (next, event) => {
    if (!location) {
      return;
    }
    const query = qs.parse(location.hash.substr(1));
    location.hash = "";
    if (query.token) {
      if (!isLikelyJwt(query.token)) {
        history.push("/");
        return;
      }
      try {
        jwtDecode(query.token);
      } catch (_err) {
        history.push("/");
        return;
      }
      logUserIn(query.token);
      // Default destination:
      //  - sign_up events route to /select-segment so new users pick a segment
      //    before seeing the main app. The marketing-site signup form posts to
      //    /api/v1/auth/signup2 and lands here with event=sign_up, so this is
      //    the single chokepoint that covers every signup path (marketing form,
      //    SignupB2C, OAuth first-time).
      //  - Anything else (returning logins, OAuth re-auth, SSO) keeps the
      //    legacy /extractdata destination so bookmarks and emails keep working.
      //  - An explicit ?next= always wins over either default.
      const defaultDest = event === "sign_up" ? "/select-segment" : "/extractdata";
      const to = next ? decodeURIComponent(next) : defaultDest;
      history.push((to || "").replace("/app", ""));
    } else {
      history.push("/");
    }
  };

  const { error, success, value, currency, event, next } = queryString.parse(
    location.search
  );

  React.useEffect(() => {
    handleJwt(next, event);
  }, []);

  if (event === "sign_up") {
    if (window && (window as any).gtag) {
      (window as any).gtag("event", "sign_up_frontend");
    }
    if (window && (window as any).lintrk) {
      (window as any).lintrk("track", { conversion_id: 10568564 });
    }
    if (window && (window as any).rdt) {
      (window as any).rdt("track", "SignUp");
    }
    // Unified PostHog event for every signup path (marketing form, SignupB2C,
    // OAuth first-time) since they all funnel through ReceiveJwt with
    // event=sign_up. Use this for funnel measurement; SignupB2C-specific
    // events fire separately for surface attribution.
    capturePostHogEvent("signup_completed", {
      source: "ReceiveJwt",
      success: success || "",
      value: value || "",
      currency: currency || "",
    });
  }

  return null;
};

export default withRouter(ReceiveJwt);
